import { fmtDuration, fmtTime } from "../geotab/geotabFormat.js";

// Fin du service lue au carnet de route, plus tard que le retour au dépôt (afterReturn) : le camion est reparti,
// ou le carnet est resté ouvert, camion immobile.
const BAR = { away: "border-[#ffc400]", idle: "border-[#c5524a]" };
const awayText = (after, prefix) => [`${prefix} ${fmtTime(after.back)}`, after.places.join(" → "), after.km != null && `${after.km} km`].filter(Boolean).join(" · ");
const idleText = (after, prefix) => `Carnet ouvert ${fmtDuration(after.end - after.back)} après le retour ${prefix} ${fmtTime(after.back)} · camion immobile`;

// small : taille du relevé ; sinon celle du texte qui l'entoure.
function Lines({ title, detail, small = false }) {
  return <span className={small ? "leading-[15px]" : ""}><span className={`block font-bold text-slate-900 ${small ? "text-[11.5px]" : ""}`}>{title}</span>
    <span className={`block text-slate-600 ${small ? "text-[11px] font-semibold" : ""}`}>{detail}</span></span>;
}

// Ligne du relevé sous « Fin du service » ; onTakeReturn : reprendre l'heure du retour au dépôt (carnet resté ouvert).
export default function ServiceEndNote({ after, colSpan, onTakeReturn = null }) {
  return <tbody><tr className="!bg-white"><td colSpan={colSpan} className="relative pb-1.5 pl-9 pr-2 pt-0 text-xs">
    <span aria-hidden="true" className="absolute bottom-0 left-[13px] top-0 w-0.5 bg-slate-200" />
    <span role="note" data-service-end-note={after.idle ? "idle" : "away"} className={`flex flex-wrap items-center gap-x-3 gap-y-1 border-l-[3px] pl-1.5 ${BAR[after.idle ? "idle" : "away"]}`}>
      {after.idle ? <Lines small title={idleText(after, "au dépôt de")} detail="Vérifiez la fin du service" />
        : <Lines small title={awayText(after, "Reparti après le retour au dépôt de")} detail={`${fmtTime(after.end)} = fin du carnet de route`} />}
      {after.idle && onTakeReturn ? <button type="button" onClick={onTakeReturn}
        className="shrink-0 rounded-[4px] border border-slate-300 bg-white px-1.5 py-0.5 text-[11px] font-semibold text-slate-800 hover:border-accent hover:text-accent focus-visible:outline-2 focus-visible:outline-accent">
        Prendre {fmtTime(after.back)}</button> : null}
    </span></td></tr></tbody>;
}

// Même avis dans la fenêtre « Ajouter les heures Geotab ? ».
export function AfterReturnLine({ after }) {
  return <span className={`mt-2 flex border-l-[3px] pl-1.5 ${BAR[after.idle ? "idle" : "away"]}`}>
    <Lines title={`Fin du service ${fmtTime(after.end)} : carnet de route`} detail={after.idle ? idleText(after, "de") : awayText(after, "Reparti après le retour de")} />
  </span>;
}
